import React, { useContext } from "react";
import { Box, Avatar, Typography, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { AuthContext } from "navigation/AuthProvider";

const UserProfileCard = () => {
  const { user } = useContext(AuthContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Avatar
        src={user.user.profile_image}
        alt={`${user.user.first_name} ${user.user.last_name}`}
        sx={{ width: 120, height: 120, border: "3px solid lightgrey" }}
      />
      <Typography
        variant="h6"
        sx={{
          marginTop: "8px",
          fontSize: "18px",
          fontWeight: "500",
          opacity: 0.8,
        }}
      >
        {user.user.first_name} {user.user.last_name}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          marginTop: "6px",
          fontSize: "16px",
          fontWeight: 800,
          opacity: 0.8,
        }}
      >
        {user.position}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", marginTop: "6px" }}>
        <EmailIcon sx={{ opacity: 0.6 }} />
        <Typography variant="h6" sx={{ fontSize: "14px", marginLeft: "5px", opacity: 0.6 }}>
          {user.user.email}
        </Typography>
      </Box>
      <Button
        variant="outlined"
        size="small"
        sx={{
          marginTop: "24px",
          color: "black",
          borderColor: "gray",
          opacity: 0.7,
          "&:hover": { borderColor: "gray" },
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontSize: "12px", fontWeight: "500", textTransform: "none" }}
        >
          View more
        </Typography>
      </Button>
    </Box>
  );
};

export default UserProfileCard;
